// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

// Dinamically change category post item bottom padding
document.addEventListener("DOMContentLoaded", function() {
  
	function imageHeight() {
	  if (document.body.classList.contains('category') || document.body.classList.contains('blog')) {

		const categoryItemArray = Array.from(document.querySelectorAll('.category-post-item'));
		categoryItemArray.forEach(categoryItem => { 
		  let categoryItemImage  =  categoryItem.querySelector('.category-post-item__category-image').clientHeight;
		  let categoryItemImageCalculated = categoryItemImage + 50;
		  
		  categoryItem.querySelector('.category-post-item__title').style.paddingBottom = categoryItemImageCalculated + 'px';
		  
		});
	  }
	}

	setTimeout(function(){
		imageHeight();
		document.body.classList.add('dom-loaded');
	},200);
  });

  // Count number of external links
  if(document.getElementsByClassName('external-counter').length) {

	document.querySelectorAll(".category-post-item").forEach(parent => {

		if (parent.querySelectorAll(".pm-link-list ul li a").length) {
			let externalLinkNumber = parent.querySelectorAll(".pm-link-list ul li a").length;
			
			parent.querySelectorAll('.count-number')[0].innerHTML = externalLinkNumber;

			if(externalLinkNumber === 1) {
				parent.querySelectorAll('.count-text')[0].innerHTML = 'resource';
			}
			else {
				parent.querySelectorAll('.count-text')[0].innerHTML = 'resources';
			}
		}
	  });
  }


if($('.header-sticky').is(":visible")) {
	$('body').addClass('sticky-header')
	let lastScrollTop = 0;
	$(window).on('scroll', function() {
		let st = $(this).scrollTop();
		if(st < lastScrollTop) {
			$('body').addClass('sticky-header--sticky');
			$('body').removeClass('sticky-header--not-sticky');
		}
		else {
			$('body').removeClass('sticky-header--sticky');
			$('body').addClass('sticky-header--not-sticky');
		}
		lastScrollTop = st;
	});
}


(() => {
    const PUMBLE_SEO_EVENTS_USER = "pumble-seo-events-user";
    const PUMBLE_SEO_EVENTS_PAGE_URL = "pumble-seo-events-page-url";
    const PUMBLE_SEO_EVENTS_VISIT_TIMESTAMP = "pumble-seo-events-visit-timestamp";

    const getPumbleSeoEventsUser = () => localStorage.getItem(PUMBLE_SEO_EVENTS_USER)
    const setPumbleSeoEventsUser = (user) => localStorage.setItem(PUMBLE_SEO_EVENTS_USER, user)
    const setPumbleSeoEventsPageUrl = (pageUrl) => localStorage.setItem(PUMBLE_SEO_EVENTS_PAGE_URL, pageUrl)
    const setPumbleSeoEventsVisitTimestamp = (timestamp) => localStorage.setItem(PUMBLE_SEO_EVENTS_VISIT_TIMESTAMP, `${timestamp}`)

    const makeSEOEventPostRequest = (data, keepAlive = false) => {
        fetch("https://api-ga.pumble.com/porcos/events/seo-events", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
            keepalive: keepAlive,
        })
            .then((response) => response)
            .catch((error) => console.error("Error: ", error));
    };

    const loadData = () => {
        if (!getPumbleSeoEventsUser()) {
            const analyticsUserId =
                Date.now().toString(36) + Math.random().toString(36).substring(2);
            setPumbleSeoEventsUser(analyticsUserId);
        }
        setPumbleSeoEventsPageUrl(window.location.href)
        setPumbleSeoEventsVisitTimestamp(Date.now())
    };

    const sendVisitRequest = () => {
        const visitAnalyticsBody = {
            event: "visit",
            userId: getPumbleSeoEventsUser(),
            pageUrl: window.location.href,
        };

        makeSEOEventPostRequest(visitAnalyticsBody);
    };

    const handleLinkClick = (event) => {
        const targetElementAnchor = event.target.closest("a");

        if (targetElementAnchor) {
            let section = targetElementAnchor.textContent.trim();
            let clickAnalyticsBody = {
                event: "click",
                userId: getPumbleSeoEventsUser(),
                pageUrl: window.location.href,
                section: section,
            };

            makeSEOEventPostRequest(clickAnalyticsBody, true);
        }
    };

    document.addEventListener("DOMContentLoaded", () => {
        loadData();
        sendVisitRequest();
    });
    document.addEventListener("click", handleLinkClick);
})();